import { isNil } from 'lodash'
import moment from 'moment'

const parseTimeToEstimationTime = (start, end) => {
  if (isNil(start) || isNil(end)) {
    return null
  }
  const startEndDiff = moment(end).diff(moment(start), 'hours', true)
  const estimationHours = parseInt(startEndDiff, 10)
  const estimationMinutes = parseInt((startEndDiff % 1) * 60, 10)

  return `${estimationHours > 9 ? estimationHours : `0${estimationHours}`}:${estimationMinutes > 9 ? estimationMinutes : `0${estimationMinutes}`}h`
}

export default parseTimeToEstimationTime
